<template>
  <div class="content-main">
    <BaseLeftPageSubMenu
      :menuItems="filteredPageOptions"
      :selectedStatus="selectedSection"
      @selectedStatusFilter="updateActualPage"
      @searchUpdated="onMenuSearch"
      :searchEnabled="true"
    >
    </BaseLeftPageSubMenu>
    <div class="content-wrapper">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreSettings",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      pageOptions: [
        {
          displayText: "General Settings",
          value: "GeneralSettings"
        },
        {
          displayText: "Critical Zone",
          value: "CriticalZone"
        },
        {
          displayText: "Admin Settings",
          value: "AdminSettings"
        },
        {
          displayText: "Orders Settings",
          value: "OrdersSettings"
        },
        {
          displayText: "Marketplaces Settings",
          value: "MarketplacesSettings"
        },
        {
          displayText: "Search Settings",
          value: "SearchSettings"
        },
        {
          displayText: "Pop up messages",
          value: "PopUpMessages"
        },
        {
          displayText: "AI models",
          value: "AiModelsSettings"
        },
        {
          displayText: "Category Manager",
          value: "CategoryManager"
        },
        {
          displayText: "Manage vehicles",
          value: "ManageVehicles"
        },
        {
          displayText: "Marketplaces Category Manager",
          value: "MarketplacesCategoryManager"
        },
        {
          displayText: "Coupons Manager",
          value: "CouponsManager"
        },
        {
          displayText: "Banner Manager",
          value: "BannersManager"
        },
        {
          displayText: "Price Lists Manager",
          value: "PriceListsManager"
        },
        {
          displayText: "Brands Manager",
          value: "BrandsManager"
        },
        {
          displayText: "Search settings",
          value: "PartsSettings"
        },
        {
          displayText: "Infoauto",
          value: "Infoauto"
        },
        {
          displayText: "Sitemaps",
          value: "SitemapsManager"
        },
        {
          displayText: "Google ADS",
          value: "GoogleAds"
        },
        {
          displayText: "Price Groups",
          value: "PriceGroups"
        },
        {
          displayText: "Catalog Pricing (B2/Z)",
          value: "CatalogPricing"
        },
        {
          displayText: "Bulk Product Upload",
          value: "BulkProductUpload"
        },
        {
          displayText: "Bulk Image Upload",
          value: "ImageBatchUpload"
        },
        {
          displayText: "Popular Products",
          value: "PopularProducts"
        },
        {
          displayText: "Other Procedures",
          value: "OtherProcedures"
        },
        {
          displayText: "Carrier Services",
          value: "CarrierServices"
        },
        {
          displayText: "Local Delivery",
          value: "LocalDelivery"
        },
        {
          displayText: "Pending Products",
          value: "PendingProducts"
        },
        {
          displayText: "Departments Manager",
          value: "DepartmentsManager"
        },
        {
          displayText: "Department Priority Settings",
          value: "DepartmentPriority"
        },
        {
          displayText: "Taxjar",
          value: "Taxjar"
        },
        {
          displayText: "Taxjar Routes",
          value: "TaxjarRoutes"
        },
        {
          displayText: "Taxjar orders",
          value: "TaxjarOrders"
        }
      ],
      selectedSection: "OrdersSettings",
      menuSearch: ""
    };
  },
  computed: {
    filteredPageOptions() {
      if (!this.menuSearch.trim()) return this.pageOptions;
      const term = this.menuSearch.trim().toLowerCase();
      return this.pageOptions.filter(item =>
        item.displayText.toLowerCase().includes(term)
      );
    }
  },
  mounted() {
    this.selectedSection = this.$route.name;
  },
  methods: {
    onMenuSearch(value) {
      this.menuSearch = value;
    },
    updateActualPage(selection) {
      if (this.$route.name != selection) {
        this.selectedSection = selection;
        this.$router.push({ name: selection }).catch(err => {
          if (err.name !== "NavigationDuplicated") {
            console.error("Navigation error:", err);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content-main {
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}

.content-wrapper {
  flex: 1;
  min-width: 0; /* Important: allows flex child to shrink below content size */
  overflow: hidden;
  padding: 1rem;
  width: 100%;

  @media screen and (max-width: 768px) {
    padding: 0.5rem;
  }
}
</style>
